import { useEffect, useState } from "react";

export default function BrowserWarning() {
  const [isFirefox, setIsFirefox] = useState(false);

  useEffect(() => {
    const ua = navigator.userAgent.toLowerCase();
    if (ua.includes("firefox")) {
      setIsFirefox(true);
    }
  }, []);

  if (!isFirefox) return null;

  return (
    <div className="bg-yellow-200 text-yellow-900 p-4 text-sm rounded-md shadow-md mb-4">
      ⚠️ This application may not work properly in Firefox due to browser-level restrictions on database connections.
      <br />
      Please consider using Chrome, Edge, or another browser for the best experience.
    </div>
  );
}
